export default "/mooezETH-wstETH-BPT.bd9644f8069de44c8822e7c49d4ce479.png";